import styled from 'styled-components';

export const EditContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 500px;
  padding: 2rem;
`;

export const EditCard = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  max-width: 800px;
  width: 100%;
`;

export const EditHeader = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  position: relative;
  
  h3 {
    margin: 1rem 0 0.5rem 0;
    color: #333;
    font-size: 1.5rem;
    font-weight: 600;
  }
  
  p {
    margin: 0 0 1rem 0;
    color: #666;
    line-height: 1.6;
    font-size: 0.9rem;
  }
`;

export const EditContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const EditSection = styled.div`
  h4 {
    margin: 0 0 1rem 0;
    color: #333;
    font-size: 1.1rem;
    font-weight: 600;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 0.5rem;
  }
`;

export const EditField = styled.div`
  margin-bottom: 1.5rem;
`;

export const EditLabel = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  color: #333;
  font-weight: 500;
  font-size: 0.9rem;
`;

export const EditInput = styled.div`
  position: relative;
`;

export const EditInfo = styled.small`
  display: block;
  margin-top: 0.25rem;
  color: #666;
  font-size: 0.8rem;
`;

export const EditToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
  
  span {
    color: #333;
    font-size: 0.9rem;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid #e0e0e0;
`;

export const StatusIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 4px solid #00C48C;
  
  span {
    color: #333;
    font-weight: 500;
    font-size: 0.9rem;
  }
`;

export const ConnectionStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 4px solid ${props => props.children[0].props.color === '#00C48C' ? '#00C48C' : '#dc3545'};
  
  span {
    color: #333;
    font-weight: 500;
    font-size: 0.9rem;
  }
`;

export const ProviderInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 6px;
  margin-top: 1rem;
`;

export const DeleteButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  font-size: 0.8rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: background-color 0.2s;
  
  &:hover:not(:disabled) {
    background: #c82333;
  }
  
  &:disabled {
    background: #6c757d;
    cursor: not-allowed;
  }
`;
